import React, {PureComponent} from 'react'
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import Paper from '@material-ui/core/Paper';
import {sendMessage} from "../../api";
import Message from "../ChatBot/components/Message";
import Header from "./components/Header";
import SendMessage from "./components/SendMessage";

const styles = theme => ({
    root: {
        float: 'left',
        width: '48%',
        marginLeft: '2%',
        borderRadius: 8,
        height: 800,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    header: {
        display: 'flex',
        height: 56,
        alignItems: 'center',
        padding: `${theme.spacing(0)}px ${theme.spacing(1)}px`,
        background: '#6e48aa',
        color: '#fff',
    },
    messageWrapper: {
        flex: 1,
        padding: `${theme.spacing(2)}px ${theme.spacing(1.5)}px`,
        background: '#f5f8fb',
    },

    messageRow: {
        display: 'flex',
        marginBottom: theme.spacing(2),
    },
    messageRowLeft: {
        paddingRight: '15%',
    },
    messageRowRight: {
        paddingLeft: '25%',
        justifyContent: 'flex-end'
    },
    messageAvatar: {
        marginTop: 'auto',
        background: '#fff',
        borderRadius: 23,
        padding: 3,
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
        marginBottom: 3,
    },
    messageAvatarLeft: {
        borderBottomRightRadius: 3,
    },
    messageAvatarRight: {
        borderBottomLeftRadius: 3,
    },
    messageActivity: {
        marginTop: 'auto',
        color: '#2196f3',
    },
    messageContainer: {},
    messageText: {
        background: '#fff',
        borderRadius: 3,
        borderBottomLeftRadius: 23,
        borderBottomRightRadius: 23,
        padding: '12px 16px',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
        marginLeft: 6,
        marginRight: 6,
        marginBottom: 3,
    },
    messageTextLeft: {
        borderTopRightRadius: 23,
        borderBottomLeftRadius: 3,
        float: 'left',
    },
    messageTextRight: {
        borderTopLeftRadius: 23,
        borderBottomRightRadius: 3,
        float: 'right',
        background: '#2196f3',
        color: '#fff',
    },
    messageTextFirst: {
        borderTopRightRadius: 23,
        borderTopLeftRadius: 23,
    },
});

class ChatBot extends PureComponent {
    state = {newMessage: ''};

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value})
    }

    onSendMessage = () => {
        this.setState({newMessage: ''})
    };

    render() {
        const {classes} = this.props;
        const {newMessage} = this.state;

        const bot = {
            name: 'Janne Kirjonen',
            nameShort: 'Janne',
            description: 'Aktiivinen tällä hetkellä',
            img: 'https://v3.material-ui.com/static/images/avatar/1.jpg',
        }

        return (
            <Paper className={classes.root} elevation={12}>
                <Header bot={bot}/>
                <div className={classes.messageWrapper}>
                    <Message sender={'bot'} bot={bot} messages={['Moikka! Miten voin olla avuksi']}/>
                    <Message sender={'self'}
                             messages={['Haluaisin saada lainatarjouksen yritykselleni. Pystytkö auttamaan?']}/>
                    <Message sender={'bot'} bot={bot}
                             messages={['Tottakai!', 'Minkälainen laina kiinnostaisi. Kuinka suuri summa ja millainen laina-aika?']}/>
                    <Message sender={'bot'} bot={bot} messages={['Päätösten ei tarvitse olla lopullisia.']}
                             showLoading={true}/>
                </div>
                <SendMessage handleChange={this.handleChange} onSendMessage={this.onSendMessage}
                             newMessage={newMessage}/>
            </Paper>
        );
    }
}

ChatBot.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ChatBot);
